<template>
  <div>
    <div class="l-container">
      <h1 class="m-label btn">集計</h1>
      <div class="wrapper">

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <th-c style="background: #f6fdff">期間検索</th-c>
              <th-c style="background: #f6fdff">AP取得日</th-c>
              <td-c><input v-model="search.acquisition_date[0]" type="text" @keyup="searchTable()" placeholder="AP取得日"></td-c>
              <td-c><input v-model="search.acquisition_date[1]" type="text" @keyup="searchTable()" placeholder="〜AP取得日"></td-c>
            </tr-c>
          </table-c>
        </div>

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <td-c></td-c>
              <th-c>DM</th-c>
              <th-c>貼紙</th-c>
              <th-c>HP</th-c>
              <th-c>紹介</th-c>
              <th-c>TEL注</th-c>
              <th-c>TA</th-c>
              <th-c>その他</th-c>
              <th-c>合計</th-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>仙台</th-c>
              <td-c>{{aggregate_appointment.sendai.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sendai.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>札幌</th-c>
              <td-c>{{aggregate_appointment.sapporo.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.sapporo.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>名古屋</th-c>
              <td-c>{{aggregate_appointment.nagoya.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.nagoya.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>福岡</th-c>
              <td-c>{{aggregate_appointment.fukuoka.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.fukuoka.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>新宿</th-c>
              <td-c>{{aggregate_appointment.shinjuku.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.shinjuku.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>大宮</th-c>
              <td-c>{{aggregate_appointment.oomiya.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.oomiya.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>高松</th-c>
              <td-c>{{aggregate_appointment.takamatsu.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takamatsu.sum.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>高崎</th-c>
              <td-c>{{aggregate_appointment.takasaki.dm.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.harigami.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.hp.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.shokai.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.telchu.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.ta.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.other.toLocaleString()}}</td-c>
              <td-c>{{aggregate_appointment.takasaki.sum.toLocaleString()}}</td-c>
            </tr-c>
          </table-c>
        </div>

        <div>
          <bar-chart
            :styles="myStyles"
            :chart-data="datacollection"
            :options="options"
          ></bar-chart>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
const url = getAPIURL() + '/api/v1/aggregate_appointments'

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_appointment',
  pageNames: 'aggregate_appointments'
}

import BarChart from '@/components/util/BarChartA.vue'

export default {
  components: {
    BarChart
  },
  data () {
    return {
      datacollection: {},
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      height: 100,

      search: {
        acquisition_date: []
      }
    }
  },
  computed: {
    aggregate_appointment () {
      return this.$store.getters.aggregate_appointment
    },
    myStyles () {
      return {
        height: `calc(${this.height}vh - 450px`,
        position: 'relative'
      }
    }
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.datacollection = {
        labels: ['DM', '貼紙', 'HP', '紹介', 'TEL注', 'TA', 'その他'],
        datasets: [
          {
            type: 'bar',
            // fill: false,
            label: '仙台',
            backgroundColor: '#F44336',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.sendai.dm,
              this.aggregate_appointment.sendai.harigami,
              this.aggregate_appointment.sendai.hp,
              this.aggregate_appointment.sendai.shokai,
              this.aggregate_appointment.sendai.telchu,
              this.aggregate_appointment.sendai.ta,
              this.aggregate_appointment.sendai.other,
              this.aggregate_appointment.sendai.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '札幌',
            backgroundColor: '#9C27B0',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.sapporo.dm,
              this.aggregate_appointment.sapporo.harigami,
              this.aggregate_appointment.sapporo.hp,
              this.aggregate_appointment.sapporo.shokai,
              this.aggregate_appointment.sapporo.telchu,
              this.aggregate_appointment.sapporo.ta,
              this.aggregate_appointment.sapporo.other,
              this.aggregate_appointment.sapporo.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '名古屋',
            backgroundColor: '#2196F3',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.nagoya.dm,
              this.aggregate_appointment.nagoya.harigami,
              this.aggregate_appointment.nagoya.hp,
              this.aggregate_appointment.nagoya.shokai,
              this.aggregate_appointment.nagoya.telchu,
              this.aggregate_appointment.nagoya.ta,
              this.aggregate_appointment.nagoya.other,
              this.aggregate_appointment.nagoya.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '福岡',
            backgroundColor: '#009688',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.fukuoka.dm,
              this.aggregate_appointment.fukuoka.harigami,
              this.aggregate_appointment.fukuoka.hp,
              this.aggregate_appointment.fukuoka.shokai,
              this.aggregate_appointment.fukuoka.telchu,
              this.aggregate_appointment.fukuoka.ta,
              this.aggregate_appointment.fukuoka.other,
              this.aggregate_appointment.fukuoka.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '新宿',
            backgroundColor: '#4CAF50',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.shinjuku.dm,
              this.aggregate_appointment.shinjuku.harigami,
              this.aggregate_appointment.shinjuku.hp,
              this.aggregate_appointment.shinjuku.shokai,
              this.aggregate_appointment.shinjuku.telchu,
              this.aggregate_appointment.shinjuku.ta,
              this.aggregate_appointment.shinjuku.other,
              this.aggregate_appointment.shinjuku.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '大宮',
            backgroundColor: '#CDDC39',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.oomiya.dm,
              this.aggregate_appointment.oomiya.harigami,
              this.aggregate_appointment.oomiya.hp,
              this.aggregate_appointment.oomiya.shokai,
              this.aggregate_appointment.oomiya.telchu,
              this.aggregate_appointment.oomiya.ta,
              this.aggregate_appointment.oomiya.other,
              this.aggregate_appointment.oomiya.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '高松',
            backgroundColor: '#FF5722',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.takamatsu.dm,
              this.aggregate_appointment.takamatsu.harigami,
              this.aggregate_appointment.takamatsu.hp,
              this.aggregate_appointment.takamatsu.shokai,
              this.aggregate_appointment.takamatsu.telchu,
              this.aggregate_appointment.takamatsu.ta,
              this.aggregate_appointment.takamatsu.other,
              this.aggregate_appointment.takamatsu.sum
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '高崎',
            backgroundColor: '#795548',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_appointment.takasaki.dm,
              this.aggregate_appointment.takasaki.harigami,
              this.aggregate_appointment.takasaki.hp,
              this.aggregate_appointment.takasaki.shokai,
              this.aggregate_appointment.takasaki.telchu,
              this.aggregate_appointment.takasaki.ta,
              this.aggregate_appointment.takasaki.other,
              this.aggregate_appointment.takasaki.sum
            ]
          }
        ]
      }
    },
    searchTable (e) {
      let that = this
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'acquisition_date'
        ]
        paramsList.forEach((e) => {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else {
            params[e] = [search[e][0]]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
        // success callback
          console.log(response)
          store.state.item.aggregate_appointment = response.data
          that.fillData()
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    getAggregateAppointment () {
      this.$store.dispatch('getAggregateAppointment')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAggregateAppointment()

      const year = new Date().getFullYear() - 1
      const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
      vm.search.acquisition_date.push(year + '-' + month)
      setTimeout(() => {
        vm.searchTable()
      }, 150)
    })
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .list-box {
    margin-bottom: 15px;
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// AggregatesAppointments.vue?09586d19